import React from "react";

const TextAreaField = (
  { className, ...rest }: React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  ref,
) => {
  return (
    <textarea
      ref={ref}
      className={className || "unchained-form-input"}
      {...rest}
    />
  );
};

export default React.forwardRef(TextAreaField);
